import { Link, useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function BookingConfirmation() {
  const { ref } = useParams();
  return (
    <div className="max-w-3xl mx-auto px-6 py-20 text-center">
      <CheckCircle2 className="w-16 h-16 text-[#D71920] mx-auto" />
      <h1 className="font-display text-4xl md:text-5xl uppercase mt-6">Service Request Received</h1>
      <p className="mt-4 text-[#555]">Thanks. We've received your Forkfix service request.</p>
      <div className="ff-card mt-8 p-6 inline-block">
        <div className="text-xs uppercase tracking-widest text-[#666]">Booking Reference</div>
        <div className="font-display text-3xl font-bold text-[#D71920] font-mono-tech" data-testid="booking-ref">{ref}</div>
      </div>
      <p className="mt-6 text-sm text-[#555]">We'll review the forklift information and requested appointment, and contact you to confirm the booking.</p>
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/" className="ff-btn-ghost">Return Home</Link>
        <Link to="/forklift-service-brisbane" className="ff-btn-dark">View Service Options</Link>
      </div>
    </div>
  );
}
